module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAAXNSR0IArs4c6QAAAMNJREFUOE+11T0KAjEYhOF3wMLCg3gDBS0sBEuv4gEstPAA9jZ2lnYKCh5tJBJ3hf2x+ZIyxTxsMvlWBCzbE2As6dwVpwAH2y9gAewk7dsyo6AZcAdGXVgIlL7Adi8WBv3DQqEf7AkMga2kQ9oPhzK2Aq4Z20g6FoFaMdtJv0TUvCUjtXDwOTrba+D03QgGayg4uIrLJ1XfUwmogZQog+00im65cdVICm2d7XlGGqMoDOpDwh6s7SnwKD5UbSdk2febeAOg2lDiIslIegAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/gor.png
// module id = 390k
// module chunks = 3